import { Thumbnail } from '@wix/design-system';
import React, { FC } from 'react';
import styles from './MediaCard.scss';
import clsx from 'clsx';

type Props = {
  imageSrc: string;
  onClick?: () => void;
  isSelected?: boolean;
};

export const MediaCard: FC<Props> = ({ imageSrc, onClick, isSelected }) => {
  return (
    <Thumbnail onClick={onClick} selected={isSelected}>
      <div className={clsx(styles.mediaCard, isSelected && styles.selected)}>
        <img className={styles.mediaCardImage} src={imageSrc} alt={imageSrc} />
      </div>
    </Thumbnail>
  );
};
